function buildAppUrl(baseUrl, siteUrl)  {
    const {search} = new URL(siteUrl);
    const appealSlug = new URLSearchParams(search).get('appeal');
    return `${baseUrl}${appealSlug? `/appeal/${appealSlug}` : ``}`;
}

export {
    buildAppUrl
};
